// react
import { useNavigate } from 'react-router-dom';

// router
import { ROUTES } from 'router';

// store
import { useGetAllServiceQuery } from 'store/api/cms';

// components
import ServiceOverviewPage from '@karehero/llama/components/pages/ServiceOverview/ServiceOverview';

/**
 * ServiceOverview shows the list of available Services.
 */
export const ServiceOverview = () => {
  // hooks
  const navigate = useNavigate();
  const { data: services } = useGetAllServiceQuery();

  return (
    <ServiceOverviewPage
      services={services}
      isLoading={!services}
      onBookCall={() => navigate(ROUTES.BOOK_CALL)}
      onLearnMore={(slug) => navigate(slug)}
    />
  );
};

export default ServiceOverview;
